


















































import {Vue, Component, Prop, Watch, Model} from 'vue-property-decorator';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import {SystemNode} from '@c/system/interfaces';
import Loading from '@c/controls/Loading.vue';
import SimpleDialog from '@c/SimpleDialog.vue';

@Component({components: {SelectionList, Loading, SimpleDialog}})
export default class SelectDialogField extends Vue {
  // Возможность очистки поля
  @Prop({type: Boolean, default: false}) nullable!: boolean;

  // Заголовок поля
  @Prop() label!: string;

  // Правила валидации
  @Prop({default: () => []}) rules!: any[];

  // Показатель Только для чтения
  @Prop({type: Boolean, default: false}) readonly!: boolean;

  // Callback для загрузки данных
  @Prop({required: true}) callbackLoadItems!: Function;

  // Ключевое поле у элементов
  @Prop({required: false, default: 'id'})
  keyFieldName!: string;

  @Prop({required: false, default: false})
  showTooltip!: boolean;

  // Список элементов для выбора
  items: any[] = [];

  // Идентификатор выбранного объекта (Модель для SelectionList)
  selectedIdModel = '';

  // Модель диалогового окна
  dialog = false;

  // Показатели загрузки и наличия ошибок
  loading = false;
  error = false;
  presetLoading = false;

  @Watch('dialog')
  onDialog(value: boolean) {
    //TODO: тут нужно определить порядок загрузки элементов
    if (value && this.selectedItem) this.selectedIdModel = this.getKey(this.selectedItem);

    if (value && !this.items.length) {
      this.loading = true;
      this.callbackLoadItems()
        .then((items: SystemNode[]) => {
          this.items = items;
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  // Модель для выбранного элемента
  // Сейчас реализована возможность выбора одного элемента из списка
  @Model('changeItem') _selectedItemId!: any;

  get selectedItemId() {
    return this._selectedItemId;
  }

  set selectedItemId(newSelectedItemId: any) {
    this.$emit('changeItem', newSelectedItemId);
  }

  get selectedItem() {
    const stub = {name: ''};
    if (!this.selectedItemId) return stub;
    const item = this.findItemById(this.selectedItemId);
    if (!item) return stub;
    return item;
  }

  findItemById(id: any) {
    const filteredItems = this.items.filter(x => this.getKey(x) === id);
    if (!filteredItems.length) return null;
    return filteredItems[0];
  }

  // Показатель возможности выбора элемента
  get canSelect() {
    return this.selectedIdModel != null;
  }

  created() {
    if (this.selectedItemId) {
      this.presetLoading = true;
      this.loading = true;
      this.callbackLoadItems()
        .then((items: SystemNode[]) => {
          if (items.length) {
            this.items = items;
            this.selectedIdModel = this.selectedItemId;
          }
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.presetLoading = false;
          this.loading = false;
        });
    }
  }

  // Получить ключ элемента
  getKey(item: any) {
    return item[this.keyFieldName];
  }

  // Действия при выборе элемента
  onSelect() {
    this.selectedItemId = this.selectedIdModel;
  }

  // Действия при очистке поля
  onClear() {
    this.selectedItemId = null;
  }
}
